<div class="page-inner-body portlet light">
  <div class="portlet-body">
    <!-- ==================== TOOLBAR SECTION ==================== -->
    <div class="table-toolbar mb-4">
      <div class="row">
        <div class="col-md-12">
          <p-toolbar styleClass="bg-white">
            <!-- Left-aligned toolbar content -->
            <div class="p-toolbar-group-start">
              <div class="d-flex flex-column justify-content-start align-items-start">
                <div class="d-flex align-items-center fs-5 fw-bold">
                  {{ 'squareSpace.manageConnections' | transloco }}
                </div>
              </div>
            </div>

            <!-- Right-aligned toolbar content -->
            <div class="p-toolbar-group-end">
              <div class="text-end">
                <!-- Connect SquareSpace Account Button -->
                <button pButton type="button" class="p-button p-button-outlined p-button-sm fw-bold shadow-sm"
                  (click)="connectWithSquareSpaceAccount()">
                  {{ 'squareSpace.connectAccount' | transloco }}
                  <i class="pi pi-plus ms-2"></i>
                </button>
              </div>
            </div>
          </p-toolbar>
        </div>
      </div>
    </div>

    <!-- ==================== SQUARESPACE ACCOUNT CARDS SECTION ==================== -->
    <div class="mt-4">
      <div class="row">
        <!-- Only show cards if there are connected accounts -->
        @if (squareSpaceSiteDetails.length > 0) {
          <!-- Loop through each connected SquareSpace site -->
          @for (squareSpaceSiteDetail of squareSpaceSiteDetails; track squareSpaceSiteDetail) {
            <div class="col-12 col-md-4 mb-3">
              <div class="card shadow-sm border-0 rounded-4 overflow-hidden h-100 bg-light-subtle position-relative">
                <div class="card-body p-4">
                  <!-- Site Title -->
                  <div class="fs-5 text-dark-emphasis mb-1">
                    {{ squareSpaceSiteDetail.SiteInfo.title }}
                  </div>
                  <!-- Site Language -->
                  <div class="text-muted small mb-3">
                    {{ squareSpaceSiteDetail.SiteInfo.language }}
                  </div>
                  <!-- Site Details -->
                  <div class="d-grid gap-2 small text-body-secondary">
                    <div>
                      {{ 'squareSpace.storeUrl' | transloco }}
                      <a [href]="squareSpaceSiteDetail.SiteInfo.url" target="_blank">
                        {{ squareSpaceSiteDetail.SiteInfo.url }}
                      </a>
                    </div>
                    <div>{{ 'squareSpace.paymentCurrency' | transloco }} {{ squareSpaceSiteDetail.SiteInfo.currency }}</div>
                    <div>{{ 'squareSpace.timeZone' | transloco }} {{ squareSpaceSiteDetail.SiteInfo.timeZone }}</div>
                  </div>
                </div>
                <!-- Options Menu Button (3 dots) -->
                <div class="position-absolute end-0 top-0 p-2">
                  <button class="btn btn-light btn-sm rounded-circle" (click)="squareSpaceMenuPanel.toggle($event)">
                    •••
                  </button>
                </div>
                <!-- Disconnect Account Menu Panel -->
                <p-overlayPanel #squareSpaceMenuPanel>
                  <div class="px-2 py-2 small text-start">
                    <div class="mb-2 text-muted fw-semibold">
                      {{ 'squareSpace.manageConnection' | transloco }}
                    </div>
                    <!-- Disconnect Button -->
                    <button pButton type="button"
                      class="p-button p-button-danger p-button-sm w-100 justify-content-center text-center"
                      (click)="onDisconnectSquareSpaceAccount(squareSpaceSiteDetail.Id); squareSpaceMenuPanel.hide()">
                      {{ 'squareSpace.disconnectAccount' | transloco }}
                    </button>
                    <!-- Disconnect Information -->
                    <div class="text-muted mt-3 small">
                      {{ 'squareSpace.disconnectIntro' | transloco }}
                      <ul class="mt-1 ps-3">
                        <li>{{ 'squareSpace.disconnectUnlink' | transloco }}</li>
                        <li>{{ 'squareSpace.disconnectStopSync' | transloco }}</li>
                        <li>{{ 'squareSpace.disconnectDisableUpdates' | transloco }}</li>
                        <li>{{ 'squareSpace.disconnectReconnect' | transloco }}</li>
                      </ul>
                      {{ 'squareSpace.disconnectConfirm' | transloco }}
                    </div>
                  </div>
                </p-overlayPanel>
              </div>
            </div>
          }
        }
      </div>
    </div>
  </div>
</div>

<!-- ==================== NO ACCOUNTS FOUND MESSAGE ==================== -->
@if (!squareSpaceSiteDetails || squareSpaceSiteDetails.length === 0) {
  <div class="text-center mt-4">
    <div class="text-muted">{{ 'squareSpace.noAccountsFound' | transloco }}</div>
  </div>
}

<!-- ==================== SYNC PRODUCTS COMPONENT ==================== -->
@if (squareSpaceSiteDetails && squareSpaceSiteDetails.length > 0) {
  <div>
    <app-sync-products [SyncProducts]="Products" [SquareSpaceSyncProducts]="squareSpaceSyncProducts">
    </app-sync-products>
  </div>
}

<!-- ==================== CONNECTION SUCCESS DIALOG ==================== -->
<p-dialog [header]="'squareSpace.connectionSuccessHeader' | transloco" [(visible)]="isConnectSquareSpaceSuccessDialogVisible"
  [modal]="true" (onHide)="closeSquareSpaceConnectionSuccessDialog()" [style]="{ 'width': '430px'}">

  <div class="d-flex flex-column align-items-center px-3 py-3 text-center">
    <!-- Success Image -->
    <img src="assets/images/tik-image.jpg" [alt]="'squareSpace.successAlt' | transloco" class="img-fluid rounded-circle" style="width: 100px;">

    <!-- Success Message -->
    <div class="h5 mt-4 text-secondary">
      {{ 'squareSpace.connectedSuccessfully' | transloco }}
    </div>

    <!-- Additional Information -->
    <div class="text-secondary">
      {{ 'squareSpace.syncEnabled' | transloco }}
    </div>
  </div>
</p-dialog>